import React from "react";
import {
  ButtonProps as MuiButtonProps,
  Box,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import { ButtonButtonControl } from "components/atoms/button/styles/button.atom.inline.styles";
interface ButtonProps extends MuiButtonProps {
  text: string;
  backgroundColor?: string;
  isLoading?: boolean;
  width?: number | string;
  onClick?: () => void;
  variant?: "contained" | "outlined" | "text";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}
type ButtonStyleProps = {
  backgroundColor: string;
  fullWidth?: boolean;
  variant: "contained" | "outlined" | "text";
  width: number | string;
};
const useStyles = makeStyles({
  base: (props: ButtonStyleProps) => ({
    height: 32,
    // smaller height
    fontWeight: 500,
    fontSize: "0.75rem",
    // small font
    padding: "0 12px",
    // reduced horizontal padding
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    // slightly smaller corners
    textTransform: "none",
    boxShadow: "none !important",
    transition: "none !important",
    minWidth: 0,
    width: props.fullWidth ? "100%" : props.width,
    color:
      props.variant === "outlined" || props.variant === "text" ? props.backgroundColor : "#ffffff",
    backgroundColor: props.variant === "contained" ? props.backgroundColor : "transparent",
    borderColor: props.variant === "outlined" ? props.backgroundColor : undefined,
    zIndex: 10,
    "&:hover": {
      filter: "brightness(95%)",
    },
  }),
  outlined: {
    backgroundColor: "transparent",
    border: "2px solid",
    "&:hover": {
      borderWidth: 3,
      backgroundColor: "rgba(0, 0, 0, 0.03)",
    },
  },
  text: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  },
});
const Button: React.FC<ButtonProps> = ({
  text,
  backgroundColor = "#E1AD01",
  isLoading = false,
  width = 100,
  onClick,
  variant = "contained",
  fullWidth,
  disabled,
  startIcon,
  endIcon,
  ...props
}) => {
  const classes = useStyles({
    backgroundColor,
    fullWidth,
    variant,
    width,
  });
  return (
    <ButtonButtonControl
      variant={variant}
      classes={{
        root: `${classes.base} ${
          variant === "outlined" ? classes.outlined : variant === "text" ? classes.text : ""
        }`,
      }}
      startIcon={!isLoading ? startIcon : undefined}
      endIcon={!isLoading ? endIcon : undefined}
      disabled={isLoading || disabled}
      onClick={onClick}
      {...props}
    >
      {isLoading ? <CircularProgress size={24} color="inherit" /> : <Box>{text}</Box>}
    </ButtonButtonControl>
  );
};
export default Button;
